require("../app/static-page.coffee")

window.pageInitFlag = false
pageInit = ->
  new window.StaticPage()

$(document).ready ->
  if window.pageInitFlag != true
    pageInit()
  window.pageInitFlag = true



// WEBPACK FOOTER //
// ./assets/javascripts/pages/news.coffee